import { api } from "@/lib/env";

type CommonConfigResponse<T> = {
  code: number;
  data: T;
  message?: string;
};

export async function fetchCommonConfig<T>(
  key: string,
  options: { silent?: boolean } = {},
): Promise<T | null> {
  try {
    const response = await fetch(api("/common/config", true), {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ key }),
    });

    if (!response.ok) {
      return null;
    }

    const body = (await response.json()) as CommonConfigResponse<T>;
    return body.code === 0 ? body.data : null;
  } catch (error) {
    if (!options.silent) {
      console.error(`Error query common/config by ${key}`, error);
    }
    return null;
  }
}
